import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { CONSENT_CATEGORIES } from "../../lib/cookieConsent";

export default function CookieConsentModal({
  initialSelection,
  onAcceptAll,
  onSave,
  onClose,
}) {
  const [selection, setSelection] = useState(initialSelection);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  const toggleCategory = (id) => {
    setSelection((current) => ({ ...current, [id]: !current[id] }));
  };

  return createPortal(
    <div className="cookie-modal-backdrop" onClick={onClose}>
      <div
        className="cookie-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cookie-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="cookie-modal-header">
          <h3 id="cookie-modal-title" className="cookie-modal-title">
            Cookie beállítások
          </h3>
          <button
            type="button"
            className="cookie-modal-close"
            aria-label="Bezárás"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <p className="cookie-modal-intro">
          Válaszd ki, mely süti-kategóriákat engedélyezed. A döntésedet
          bármikor módosíthatod a lábjegyzet "Cookie beállítások" gombjával.
        </p>

        <div className="cookie-modal-categories">
          {CONSENT_CATEGORIES.map((category) => (
            <div className="cookie-category" key={category.id}>
              <div className="cookie-category-row">
                <span className="cookie-category-label">
                  {category.label}
                  {category.required && (
                    <span className="cookie-category-badge">
                      Mindig aktív
                    </span>
                  )}
                </span>
                <label
                  className={`cookie-switch${category.required ? " is-disabled" : ""}`}
                >
                  <input
                    type="checkbox"
                    checked={Boolean(selection[category.id])}
                    disabled={category.required}
                    onChange={() => toggleCategory(category.id)}
                    aria-label={category.label}
                  />
                  <span className="cookie-switch-track" />
                </label>
              </div>
              <p className="cookie-category-description">
                {category.description}
              </p>
            </div>
          ))}
        </div>

        <div className="cookie-modal-actions">
          <button
            type="button"
            className="cookie-banner-btn cookie-banner-btn-reject"
            onClick={() => onSave(selection)}
          >
            Kijelöltek mentése
          </button>
          <button
            type="button"
            className="cookie-banner-btn cookie-banner-btn-accept"
            onClick={onAcceptAll}
          >
            Mindent elfogadok
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
